import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { useI18n } from '@design-system/i18n';
const Wrapper = styled(Box).attrs(() => ({
    flexDirection: {
        _: 'column-reverse',
        m: 'column-reverse',
        l: 'row',
        xl: 'row',
    },
    width: { _: '100%', m: '75%', l: '75%', xl: '75%' },
    alignItems: { _: 'flex-start', m: 'flex-end' },
    justifyContent: { _: 'unset', l: 'flex-end' },
    flexWrap: { _: 'wrap', m: 'wrap', l: 'nowrap', xl: 'nowrap' },
    mt: { _: 6, m: 0, l: 5, xl: 5 },
    ml: { _: 0, m: 0, l: 65, xl: 0 },
    mr: { _: 0, m: 86, l: 0, xl: 90 },
    mb: { _: 8, m: 0, l: 0, xl: 0 },
})) ``;
export const ButtonsContainer = ({ handleAndCloseBanner, setDisplayModal, }) => {
    const { __ } = useI18n();
    return (_jsx(Box, { alignItems: "center", justifyContent: "center", minHeight: "100%", width: "100%", children: _jsxs(Wrapper, { children: [_jsx(Box, { alignItems: "center", justifyContent: "center", children: _jsx(Button, { "aria-label": "Manage cookie preferences", dataTestId: "banner-manage-cookie-preferences-button", ml: 3, mt: { _: 3, m: 3, l: 1, xl: 1 }, onClick: () => setDisplayModal(true), children: __('Manage preferences') }) }), _jsxs(Box, { alignItems: {
                        _: 'flex-start',
                        m: 'center',
                        l: 'center',
                        xl: 'center',
                    }, flexDirection: { _: 'column', m: 'row', l: 'row', xl: 'row' }, justifyContent: "flex-end", children: [_jsx(Button, { dataTestId: "banner-accept-required-button", ml: 3, mt: 1, onClick: () => handleAndCloseBanner('acceptRequired'), children: __('Accept required') }), _jsx(Button, { dataTestId: "banner-accept-all-button", ml: 3, mt: { _: 3, m: 1, l: 1, xl: 1 }, onClick: () => handleAndCloseBanner('acceptAll'), children: __('Accept all') })] })] }) }));
};
//# sourceMappingURL=ButtonsContainer.js.map